module.exports = __webpack_public_path__ + "static/img/bg_Cloud_1.194f7544.png";